import { render, staticRenderFns } from "./ReportsCards.vue?vue&type=template&id=5da978be&scoped=true"
import script from "./ReportsCards.vue?vue&type=script&lang=js"
export * from "./ReportsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da978be",
  null
  
)

export default component.exports